let imageUpdateDropzone = $('div.image-update-dropzone')
imageUpdateDropzone.dropzone({
    url: imageUpdateDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        let thisDropzone = this;
        let url = imageUpdateDropzone.attr('data-content-url');
        if (url && url.length > 0) {
            $.get(url, function (data) {
                if (data.length > 0) {
                    $.each(data, function (key, value) {
                        let mockFile = {
                            id: value.id,
                            name: value.name,
                            size: value.size,
                            dataURL: value.url
                        };

                        thisDropzone.files.push(mockFile);
                        thisDropzone.emit('addedfile', mockFile);
                        $(mockFile.previewElement).attr('data-id', value.id);

                        thisDropzone.createThumbnailFromUrl(
                            mockFile,
                            thisDropzone.options.thumbnailWidth, thisDropzone.options.thumbnailHeight,
                            thisDropzone.options.thumbnailMethod, true, function (thumbnail) {
                                thisDropzone.emit('thumbnail', mockFile, thumbnail);
                            }
                        );

                        thisDropzone.emit('complete', mockFile);
                    });
                }
            });
        }

        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        if (files.length > 0) {
            $(files).each(function (i, v) {
                v.previewTemplate.setAttribute('data-id', response.files[i].id);
            })
        }
    },
    removedfile: function (file) {
        let server_file = $(file.previewTemplate);
        let id = server_file.attr("data-id");
        if (id) {
            $.ajax({
                url: imageUpdateDropzone.attr('data-delete'),
                type: "DELETE",
                data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
                success: (data) => {
                    if (data.status) {
                        server_file.remove();
                    }

                },
                error: function (data) {
                }
            });
        }
    }
});


let docUpdateDropzone = $('div.doc-update-dropzone')
docUpdateDropzone.dropzone({
    url: docUpdateDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        let thisDropzone = this;
        let url = docUpdateDropzone.attr('data-content-url');
        if (url && url.length > 0) {
            $.get(url, function (data) {
                if (data.length > 0) {
                    $.each(data, function (key, value) {
                        let mockFile = {
                            id: value.id,
                            name: value.name,
                            size: value.size,
                            dataURL: value.url
                        };

                        thisDropzone.files.push(mockFile);
                        thisDropzone.emit('addedfile', mockFile);
                        $(mockFile.previewElement).attr('data-id', value.id);

                        thisDropzone.createThumbnailFromUrl(
                            mockFile,
                            thisDropzone.options.thumbnailWidth, thisDropzone.options.thumbnailHeight,
                            thisDropzone.options.thumbnailMethod, true, function (thumbnail) {
                                thisDropzone.emit('thumbnail', mockFile, thumbnail);
                            }
                        );

                        thisDropzone.emit('complete', mockFile);
                    });
                }
            });
        }

        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        if (files.length > 0) {
            $(files).each(function (i, v) {
                v.previewTemplate.setAttribute('data-id', response.files[i].id);
            })
        }
    },
    removedfile: function (file) {
        let server_file = $(file.previewTemplate);
        let id = server_file.attr("data-id");
        if (id) {
            $.ajax({
                url: docUpdateDropzone.attr('data-delete'),
                type: "DELETE",
                data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
                success: (data) => {
                    if (data.status) {
                        server_file.remove();
                    }
                },
                error: function (data) {
                }
            });
        }
    }
});

let videoUpdateDropzone = $('div.video-update-dropzone')
videoUpdateDropzone.dropzone({
    url: videoUpdateDropzone.attr('data-url'),
    autoProcessQueue: true,
    uploadMultiple: true,
    parallelUploads: 1,
    addRemoveLinks: true,
    maxFiles: 10,
    dictDefaultMessage: window.language['dropzone']['defaultMessage'],
    dictFallbackMessage: window.language['dropzone']['fallbackMessage'],
    dictFallbackText: window.language['dropzone']['fallbackText'],
    dictFileTooBig: window.language['dropzone']['fileTooBig'],
    dictInvalidFileType: window.language['dropzone']['invalidFileType'],
    dictResponseError: window.language['dropzone']['responseError'],
    dictCancelUpload: window.language['dropzone']['cancelUpload'],
    dictCancelUploadConfirmation: window.language['dropzone']['cancelUploadConfirmation'],
    dictRemoveFile: window.language['dropzone']['removeFile'],
    dictMaxFilesExceeded: window.language['dropzone']['maxFilesExceeded'],
    init: function () {
        let thisDropzone = this;
        let url = videoUpdateDropzone.attr('data-content-url');

        if (url && url.length > 0) {
            $.get(url, function (data) {
                if (data.length > 0) {
                    $.each(data, function (key, value) {
                        let mockFile = {
                            id: value.id,
                            name: value.name,
                            size: value.size,
                            dataURL: value.url
                        };

                        thisDropzone.files.push(mockFile);
                        thisDropzone.emit('addedfile', mockFile);
                        $(mockFile.previewElement).attr('data-id', value.id);

                        thisDropzone.createThumbnailFromUrl(
                            mockFile,
                            thisDropzone.options.thumbnailWidth, thisDropzone.options.thumbnailHeight,
                            thisDropzone.options.thumbnailMethod, true, function (thumbnail) {
                                thisDropzone.emit('thumbnail', mockFile, thumbnail);
                            }
                        );

                        thisDropzone.emit('complete', mockFile);
                    });
                }
            });
        }

        this.on("sending", function (file, xhr, formData) {
            formData.append("form_uuid", $('#form_uuid').val());
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        });
    },
    error: function (file) {
        $(file.previewElement).remove();
    },
    success: function (files, response) {
        if (files.length > 0) {
            $(files).each(function (i, v) {
                v.previewTemplate.setAttribute('data-id', response.files[i].id);
            })
        }
    },
    removedfile: function (file) {
        let server_file = $(file.previewTemplate);
        let id = server_file.attr("data-id");
        if (id) {
            $.ajax({
                url: videoUpdateDropzone.attr('data-delete'),
                type: "DELETE",
                data: {"_token": $('meta[name="csrf-token"]').attr('content'), 'id': id},
                success: (data) => {
                    if (data.status) {
                        server_file.remove();
                    }
                },
                error: function (data) {
                }
            });
        }
    }
});
